// Per-Case activity timeline — the case-scoped audit_log slice.

import { cases as casesApi } from "../../lib/api";
import { useAsync } from "../../hooks/useAsync";

const ACTION_LABEL: Record<string, string> = {
  "case.create": "Created Case",
  "case.update": "Updated Case",
  "case.delete": "Deleted Case",
  "case.archive": "Archived Case",
  "case.unarchive": "Unarchived Case",
  "case.document.associate": "Linked document to Case",
  "case.document.disassociate": "Unlinked document from Case",
  "case.draft.create": "Generated DWC-154 draft",
  "case.cross_check.run": "Ran cross-check on document",
  "case.cross_check.verdict.override": "Overrode a cross-check verdict",
};

interface Props {
  caseId: number;
}

export function CaseActivityTab({ caseId }: Props): JSX.Element {
  const { data, loading, error } = useAsync(() => casesApi.activity(caseId), [caseId]);

  return (
    <section className="card p-5">
      <h2 className="mb-3 text-lg font-medium text-slate-800">Activity</h2>
      {loading && <p className="text-sm text-slate-500">Loading…</p>}
      {error && <p className="text-sm text-red-700">Could not load activity: {error.message}</p>}
      {data && data.entries.length === 0 && (
        <p className="text-sm text-slate-600">No activity yet for this Case.</p>
      )}
      {data && data.entries.length > 0 && (
        <ol role="list" className="space-y-3">
          {data.entries.map((e) => (
            <li key={e.id} className="border-l-2 border-brand-300 pl-3 text-sm">
              <div className="font-medium text-slate-800">
                {ACTION_LABEL[e.action] ?? e.action}
              </div>
              <div className="text-xs text-slate-500">
                {new Date(e.timestamp).toLocaleString()} · user #{e.user_id}
                {e.request_ip && <span> · {e.request_ip}</span>}
              </div>
              {e.grant_reason && (
                <div className="mt-1 font-mono text-xs text-slate-500">{e.grant_reason}</div>
              )}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
